<template>
  <pre><code class="language-html">{{ code }}</code></pre>
</template>


<script>
import Prism from "prismjs";
import 'prismjs/themes/prism-coy.css';

import "prismjs/components/prism-javascript";
import "prismjs/components/prism-markup"; // for HTML

export default {
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },

    helpText: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },

  computed: {
    code() {
      return this.modelValue;
    },
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newVal) {
        this.code = newVal;
        this.$nextTick(() => {
          Prism.highlightAll();
        });
      },
    },
  },
  mounted() {
    Prism.highlightAll();
  },
};
</script>